import { useState, useEffect } from 'react'
import { YearActivityGraph } from './YearActivityGraph'

interface DashboardHeaderProps {
  title?: string
  subtitle?: string
}

export function DashboardHeader({
  title = 'Overview',
  subtitle,
}: DashboardHeaderProps) {
  const [time, setTime] = useState(new Date())

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000)
    return () => clearInterval(timer)
  }, [])

  return (
    <header className="flex flex-col sm:flex-row sm:justify-between sm:items-end gap-4 mb-6 md:mb-10 pb-4 border-b border-white/5">
      <div>
        <h1 className="text-2xl sm:text-3xl font-medium tracking-tight bg-gradient-to-br from-white to-white/50 bg-clip-text text-transparent">
          {title}
        </h1>
        {subtitle && (
          <p className="text-[#888888] text-xs sm:text-sm mt-1">
            Focus: <span className="text-emerald-400">{subtitle}</span>
          </p>
        )}
      </div>
      <div className="flex items-center justify-between sm:justify-end gap-3 sm:gap-6 text-sm font-mono">
        <div className="text-left sm:text-right">
          <div className="text-lg leading-none text-[#EEEEEE]">
            {time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </div>
          <div className="text-xs text-[#888888]">
            {time.toLocaleDateString(undefined, {
              weekday: 'long',
              month: 'short',
              day: 'numeric',
            })}
          </div>
        </div>
        <YearActivityGraph />
      </div>
    </header>
  )
}

